let momentFormat = () => {
  return (datetime, format) => {
  	format = format || 'LLLL';
  	let momentDate = moment(datetime);
  	return momentDate.isValid() ? momentDate.format(format) : 'Data inválida';
  }
};

momentFormat.$inject = [];

export default momentFormat;



// WEBPACK FOOTER //
// ./client/app/common/filters/moment-format.js